import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  premiumCalculatorLayoutContent,
} from "../actions/Utils";
import PremiumcalCulatorform from "../components/contactus/PremiumcalCulatorform";

const PremiumCalculator = ({ slug }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  // Redux state
  const premiumcalculatorlayout = useSelector(
    (state) => state.contents.premiumcalculator_layout
  );
  // const utils = useSelector((state) => state.utils);

  // Fetch layout content on mount
  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    const fetchSlug = slug || location.pathname;
    dispatch(premiumCalculatorLayoutContent({ slug: fetchSlug }));
  }, [dispatch, location.pathname, slug]);

  const calculatorlayout = premiumcalculatorlayout?.content || {};
  return (
    <Fragment>
      <section className="premium-calculator">
        <div className="container">
          <section className="contact-from-section">
            <PremiumcalCulatorform data={calculatorlayout} />
          </section>
        </div>
      </section>
    </Fragment>
  );
};

export default PremiumCalculator;
